import _ from "lodash";

export const hasCowNameBeenChosen = function (cowPollDetails) {
    return cowPollDetails && cowPollDetails.chosenName;
};